import { render, staticRenderFns } from "./PanelFact.vue?vue&type=template&id=012ad38a&"
import script from "./PanelFact.vue?vue&type=script&lang=js&"
export * from "./PanelFact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports